
<div class="content-box principal-content container">
    <p class="principal-title">{{ 'stt.home.search' | translate }} <label style="font-size: 12px;">({{ 'stt.search.notOptions' | translate }})</label></p>
    
    <div class="content-box-search" *ngIf="showAdvancedFilters === false">
        <div>
            <div class="col-md-4">
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>
                            <mat-icon aria-hidden="false" aria-label="date_range">date_range</mat-icon>
                            {{ 'stt.home.since' | translate }}
                        </mat-label>
                        <input [formControl]="startDate" matInput [matDatepicker]="picker1" placeholder="{{ 'stt.home.since_placeholder' | translate }}">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="startDate.invalid">{{ 'stt.home.invaliddate' | translate }}</mat-error>
                </div>
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>
                            <mat-icon aria-hidden="false" aria-label="date_range">date_range</mat-icon>
                            {{ 'stt.home.until' | translate }}
                        </mat-label>
                        <input [formControl]="endDate" matInput [matDatepicker]="picker2" placeholder="{{ 'stt.home.until_placeholder' | translate }}">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="endDate.invalid">{{ 'stt.home.invaliddate' | translate }}</mat-error>
                </div>
            </div>
            <div class="col-md-4">
                <mat-form-field class="w-100">
                    <mat-label>
                        <mat-icon aria-hidden="false" aria-label="groups">groups</mat-icon>{{
                        'stt.home.meetingcommittee' | translate }}
                    </mat-label>
                    <input type="text" matInput [formControl]="typeForm" [matAutocomplete]="auto"
                        placeholder="Reunión/Comité" #typeF>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option [value]="null" (click)="SelectedMeeting(null)">{{ 'stt.home.select' | translate }}..</mat-option>
                        <mat-option *ngFor="let option of filterMeetingOptions | async" [value]="option.topics" (click)="SelectedMeeting(option.meetingId)">
                            {{option.topics}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <div class="col-md-4">
                <input class="checkbox" type="checkbox" [(ngModel)]="showAdvancedFilters" name="checkFalse"
                    [ngModelOptions]="{standalone: true}">{{ 'stt.home.advancedsearch' | translate }}
            </div>
            <div class="row mb-3s">
                <div class="col-md-12">
                    <button class="button-primary" (click)="search()">{{ 'stt.home.searchtranscript' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="content-box-search" *ngIf="showAdvancedFilters">
        <div>
            <div class="row mb-3s">
                <div class="col-md-4">
                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>
                                <mat-icon aria-hidden="false" aria-label="date_range">date_range</mat-icon>
                                {{ 'stt.home.since' | translate }}
                            </mat-label>
                            <input [formControl]="startDate" matInput [matDatepicker]="picker1" placeholder="{{ 'stt.home.since_placeholder' | translate }}">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                        <mat-error *ngIf="startDate.invalid"> {{ 'stt.home.invaliddate' | translate }}</mat-error>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>
                                <mat-icon aria-hidden="false" aria-label="date_range">date_range</mat-icon>
                                {{ 'stt.home.until' | translate }}
                            </mat-label>
                            <input [formControl]="endDate" matInput [matDatepicker]="picker2" placeholder="{{ 'stt.home.until_placeholder' | translate }}">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                        <mat-error *ngIf="endDate.invalid">{{ 'stt.home.invaliddate' | translate }}</mat-error>
                    </div>
                </div>

                <div class="col-md-4">
                    <mat-form-field class="w-100">
                        <mat-label>
                            <mat-icon aria-hidden="false" aria-label="record_voice_over">record_voice_over</mat-icon>
                            {{ 'stt.home.speaker' | translate }}
                        </mat-label>
                        <input [formControl]="oratorForm" placeholder="{{ 'stt.home.speaker_placeholder' | translate }}" matInput type="text"
                            [matAutocomplete]="auto" #oratorF>
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option [value]="null" (click)="resetOratorForm()">{{ 'stt.home.select' | translate }}...</mat-option>
                            <mat-option *ngFor="let user of filterUserOptions | async" [value]="user">
                                <div (click)="optionClicked($event, user)">
                                    <mat-checkbox [checked]="user.selected" (change)="toggleSelection(user)"
                                        (click)="$event.stopPropagation()">
                                        {{user.userName}}
                                    </mat-checkbox>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <mat-form-field class="w-100">
                        <mat-label>
                            <mat-icon aria-hidden="false" aria-label="description">description</mat-icon>
                            {{ 'stt.home.agendatopic' | translate }}
                        </mat-label>
                        <input [formControl]="agendaForm" matInput placeholder="{{ 'stt.home.agenda_placeholder' | translate }}">
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="username != ''">
                <div class="col-md-4">
                    <mat-form-field class="w-100">
                        <mat-label>
                            <mat-icon aria-hidden="false" aria-label="groups">groups</mat-icon> {{
                            'stt.home.meetingcommittee' | translate }}
                        </mat-label>
                        <input type="text" aria-label="Number" matInput [formControl]="typeForm"
                            [matAutocomplete]="auto" #typeF>
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option [value]="null" (click)="SelectedMeeting(null)">{{ 'stt.home.select' | translate }}...</mat-option>
                            <mat-option *ngFor="let option of filterMeetingOptions | async" [value]="option.topics" (click)="SelectedMeeting(option.meetingId)">
                                {{option.topics}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="col-md-4">

                    <mat-form-field class="w-100">
                        <mat-label>
                            <mat-icon aria-hidden="false" aria-label="flag">flag</mat-icon>{{ 'stt.home.directorcountry'
                            | translate }}
                        </mat-label>
                        <input [formControl]="countryForm" placeholder="{{ 'stt.home.director_placeholder' | translate }}" matInput type="text"
                            [matAutocomplete]="countryAuto" #countryF>
                        <mat-autocomplete autoActiveFirstOption #countryAuto="matAutocomplete">
                            <mat-option [value]="null" (click)="resetCountryForm()">{{ 'stt.home.select' | translate }}...</mat-option>
                            <mat-option *ngFor="let opt of filterCountryOptions | async" [value]="opt.name">
                                {{ opt.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100">
                        <mat-label>
                            <mat-icon aria-hidden="false" aria-label="notes">notes</mat-icon>{{ 'stt.home.keyword' |
                            translate }}
                        </mat-label>
                        <input [formControl]="textForm" matInput
                        placeholder="{{ 'stt.home.keyword_placeholder' | translate }}">
                    </mat-form-field>
                </div>
            </div>
            <div class="row mb-3s">
                <div class="col-md-4 offset-md-4">
                    <button class="button-primary" (click)="search()">{{ 'stt.home.searchtranscript' | translate }}</button>
                </div>
                <div class="col-md-4">
                    <input class="checkbox" type="checkbox" *ngIf="!isDirectory" [(ngModel)]="showAdvancedFilters"
                        name="checkTrue" [ngModelOptions]="{standalone: true}">
                    <label *ngIf="!isDirectory"> {{ 'stt.home.advancedsearch' | translate }}</label>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="ver || username != 'directory'">
        <div class="d-flex justify-content-center spinner-content" *ngIf="finding">
            <div class="py-5">
                <mat-spinner [diameter]="70" [strokeWidth]="2"></mat-spinner>
            </div>
        </div>
        <div *ngIf="searchLoading">
            <div class="content-box second-content" *ngIf="username != 'directory'">
                <p class="second-title">{{ 'stt.home.mostrecenttranscripts' | translate }}</p>
            </div>

            <div class="result">
                <p><strong>{{ dataSource?.data.length }}</strong> {{ 'stt.home.searchresults' | translate }} </p>
            </div>
            <div class="table-result">
                <table mat-table class="w-100" [dataSource]="dataSource" matSort aria-label="Elements" >
                    <caption></caption>
                    <ng-container matColumnDef="idMeeting">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">{{ 'stt.home.meetingID' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <div *ngIf="!showAdvancedFilters">
                                <button class="button-secondary transcription"
                                    (click)="openModalMeeting(row.idMeeting, row.directory, row.date, 0)">
                                    <mat-icon aria-hidden="false" aria-label="search">search</mat-icon>
                                    {{row.idMeeting}}
                                </button>
                            </div>
                            <div *ngIf="showAdvancedFilters">
                                <button class="button-secondary transcription"
                                    (click)="openModalMeeting(row.idMeeting, row.directory, row.date, row.idTranscription)">
                                    <mat-icon aria-hidden="false" aria-label="search">search</mat-icon>
                                    {{row.idMeeting}}
                                </button>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">{{ 'stt.home.meetingdate' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let row">{{row.date | date:"MMMM d, y"}}</td>
                    </ng-container>
                    <ng-container matColumnDef="directory" *ngIf="!showAdvancedFilters">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">{{ 'stt.home.committeename' | translate }}
                        </th>
                        <td  mat-cell *matCellDef="let row"><label matTooltipClass="stt-tooltip" #tooltip="matTooltip"
                                matTooltipPosition="above" matTooltip="{{row.directory}}">
                                {{(row.directory.length > 100) ? ((row.directory).slice(0,100) + '...'):
                                row.directory}}</label></td>
                    </ng-container>
                    <ng-container matColumnDef="directory" *ngIf="showAdvancedFilters">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">{{ 'stt.home.committeename' | translate }}
                        </th>
                        <td  mat-cell *matCellDef="let row"><label matTooltipClass="stt-tooltip" #tooltip="matTooltip"
                                matTooltipPosition="above" matTooltip="{{row.directory}}">
                                {{(row.directory.length > 50) ? ((row.directory).slice(0,50) + '...'):
                                row.directory}}</label></td>
                    </ng-container>
                    <ng-container matColumnDef="transcription">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">{{ 'stt.home.transcription' |
                            translate }}</th>
                        <td mat-cell *matCellDef="let row">
                            <button class="button-secondary transcription"
                                [routerLink]="['/app/transcription', row.idMeeting, row.idTranscription, row.start ]">
                                <mat-icon aria-hidden="false" aria-label="article">article</mat-icon>{{
                                'stt.home.view' | translate }}
                            </button>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="diary">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">{{ 'stt.home.agendatopic' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <label matTooltipClass="stt-tooltip" #tooltip="matTooltip" matTooltipPosition="above" matTooltip="{{row.diary}}">
                                {{(row.diary.length > 50) ? ((row.diary).slice(0,50) + '...'):row.diary}}
                            </label>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="speaker">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">{{ 'stt.home.speaker' | translate }}</th>
                        <td mat-cell *matCellDef="let row">
                            <label matTooltipClass="stt-tooltip" #tooltip="matTooltip" matTooltipPosition="above"
                                matTooltip="{{row.speaker}}">{{(row.speaker.length > 50) ? ((row.speaker).slice(0,50) +
                                '...'): row.speaker}}</label>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="country">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">{{ 'stt.home.country' | translate }}</th>
                        <td mat-cell *matCellDef="let row">
                            <label>{{row.country}}</label>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="audio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">{{ 'stt.home.audio' | translate }}</th>
                        <td mat-cell *matCellDef="let row">
                            <mat-select class="select-form" placeholder="Audio">
                                <mat-option (click)="openModalAudio(row, 'Flo')" value="1">Floor</mat-option>
                                <mat-option (click)="openModalAudio(row, 'Spa')" value="2">{{ 'stt.home.spanish' |
                                    translate }}</mat-option>
                                <mat-option (click)="openModalAudio(row, 'Eng')" value="3">{{ 'stt.home.english' |
                                    translate }}</mat-option>
                            </mat-select>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="editDownloadTranscript">
                        <th mat-header-cell *matHeaderCellDef scope="col">{{ 'stt.home.editdownloadtranscript' | translate }} </th>
                        <td mat-cell *matCellDef="let row" style="font-size: small;">
                            <mat-select class="select-form mat-cell" placeholder="{{ 'stt.home.opciones' | translate }}">
                                <mat-option [disabled]="row.btnDisabled" [routerLink]="['/app/edit', row.idMeeting, row.idTranscription, row.start ]">
                                        <mat-icon aria-hidden="false" aria-label="create" *ngIf="!row.btnDisabled">create</mat-icon>
                                        <mat-icon aria-hidden="false" aria-label="create" *ngIf="row.btnDisabled" style="opacity: 0.3;"
                                        matTooltipClass="stt-tooltip" #tooltip="matTooltip" matTooltipPosition="above"
                                        matTooltip="{{ 'stt.edit.editBy' | translate}} {{ row.editBy }}">create</mat-icon>                                
                                        {{ 'stt.home.edit' | translate }}
                                </mat-option>
                                <mat-option (click)="DownloadPdf(row.idMeeting)">
                                        <mat-icon aria-hidden="false" aria-label="get_app">get_app</mat-icon>PDF
                                </mat-option>
                                <mat-option (click)="DownloadWord(row.idMeeting)">
                                        <mat-icon aria-hidden="false" aria-label="get_app">get_app</mat-icon>WORD
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="download">
                        <th mat-header-cell *matHeaderCellDef scope="col">{{ 'stt.home.downloadtranscript' | translate }}</th>
                        <td mat-cell *matCellDef="let row">
                            <button class="button-secondary edit" (click)="DownloadPdf(row.idMeeting)">
                                <mat-icon aria-hidden="false" aria-label="get_app">get_app</mat-icon>{{
                                    'stt.home.downloadPDF' | translate }}
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.selected]="row.isSelected"></tr>
                </table>
                <mat-paginator *ngIf="dataSource?.data.length > 10" #paginator [length]="dataSource?.data.length" [pageIndex]="0" [pageSize]="10"
                    [pageSizeOptions]="[10, 20, 40]">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>